import React from 'react';
export const WPRoutesStoreContext = React.createContext(undefined);
export const useWPRoutesStore = () => React.useContext(WPRoutesStoreContext);
